import { apFinalizedService } from "../services";

const state = {
  items: [],
  item: {},
  loading: true
};

// ACTIONS
const actions = {

  // by id
  GET_AP_FINALIZED_BY_ID({ commit }, options) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apFinalizedService.getById(options.id).then(
        apFinalized => {
          commit("fetchItemSuccess", apFinalized);
          resolve(apFinalized);
        },
        error => {
          commit("getAPFail");
          reject(error);
        }
      );
    });
  },

  //get list of accept protocols, paginated
  GET_AP_FINALIZED_LIST({ dispatch, commit }, options) {
    // triger mutation -> loading = true
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apFinalizedService.getList(options).then(
        response => {
          commit("fetchItemsSuccess", response.data);
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  //get list of accept protocols for stats
  GET_AP_FINALIZED_STATS({ commit }, options) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apFinalizedService.getStats(options).then(
        response => {
          commit("fetchItemsSuccess", response.data);
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  CREATE_CUSTOMER_URL({ dispatch, commit }, options) {
    return new Promise((resolve, reject) => {
      apFinalizedService.createCustomerUrl(options).then(
        apMeta => {
          commit("customerUrlAdded", apMeta);
          resolve(apMeta);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // get the pdf version of the finalized ap
  GET_PDF({ }, options) {
    return new Promise((resolve, reject) => {
      apFinalizedService.getPdf(options).then(
        pdfBlob => {
          resolve(pdfBlob);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // get by slug (url sent to cusomer)
  GET_CLOSURE({ commit }, options) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apFinalizedService.getBySlug(options).then(
        apFinalized => {
          commit("fetchItemSuccess", apFinalized);
          resolve(apFinalized);
        },
        error => {
          commit("getAPFail");
          reject(error);
        }
      );
    });
  },

  // get by slug (url sent to cusomer)
  AUTH_CLOSURE({ commit }, options) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apFinalizedService.authClosure(options).then(
        apFinalized => {
          commit("fetchItemSuccess", apFinalized);
          resolve(apFinalized);
        },
        error => {
          commit("getAPFail");
          reject(error);
        }
      );
    });
  },

  // add the closure values for that meta
  // [{closureQuestion_id: 3,comment: "",meta_id: 105,value: 2},{...},{...}]
  SUBMIT_STARS({ commit }, options) {

    return new Promise((resolve, reject) => {
      apFinalizedService.submitStars(options).then(
        apFinalized => {
          commit("fetchItemSuccess", apFinalized);
          resolve(apFinalized);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

// MUTATIONS
const mutations = {
  // http request fails
  getAPFail(state) {
    state.loading = false;
    state.item = {};
  },
  // http request sent
  requestSent(state) {
    state.loading = true;
  },
  // single model
  fetchItemSuccess(state, item) {
    state.loading = false;
    state.item = item;
  },
  // all models
  fetchItemsSuccess(state, items) {
    state.loading = false;
    state.items = items;
  },
  // new closure url added add it to item.meta
  customerUrlAdded(state, apMeta) {
    state.item.meta.unshift(apMeta);
  },
};


// EXPORT
export const apFinalized = {
  namespaced: true,
  state,
  actions,
  mutations
};
